import { Button, Group, LoadingOverlay, Stack } from '@mantine/core'

import { Toast } from '#components/Toast'
import { noop } from '#util'

export interface ModalFormProps {
  onConfirm?: (e?: React.FormEvent<HTMLFormElement>) => void
  onClose: () => void
  children?: React.ReactNode
  loading?: boolean
  disabled?: boolean
  dangerous?: boolean
  confirmLabel?: string
  cancelLabel?: string
  errorMessage?: React.ReactNode
}

export function ModalForm(props: ModalFormProps) {
  const {
    onConfirm = noop,
    onClose,
    children,
    disabled,
    loading,
    dangerous,
    confirmLabel,
    cancelLabel,
    errorMessage,
  } = props
  const confirmButtonVariant = dangerous ? 'danger' : undefined

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    if (!(disabled || loading)) {
      onConfirm(e)
    }
  }

  return (
    <>
      <LoadingOverlay visible={!!loading} />
      <form onSubmit={handleSubmit}>
        <Stack>
          {children}
          {errorMessage && (
            <Toast
              icon="fa fa-exclamation-triangle"
              type="error"
              message={errorMessage}
              dismissable={false}
            />
          )}
          {(confirmLabel || cancelLabel) && (
            <Group gap="xs" justify="center">
              {confirmLabel && (
                <Button
                  type="submit"
                  variant={confirmButtonVariant}
                  disabled={disabled}
                  data-autofocus
                >
                  {confirmLabel}
                </Button>
              )}
              {cancelLabel && (
                <Button variant="outline" onClick={onClose}>
                  {cancelLabel}
                </Button>
              )}
            </Group>
          )}
        </Stack>
      </form>
    </>
  )
}
